module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Map Click Info":"Kartenklickinfo","Click on the map to get information for the clicked map position.":"Klicken Sie auf die Karte, um Informationen zur angeklickten Kartenposition zu erhalten."}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/infoclick/InfoClickWin.vue
// module id = Lg3E
// module chunks = 1